import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import logo from '../Assets/Wolf.png';
import './GlobalSpinner.css'; // Ensure this CSS file is imported

const GlobalSpinner = () => {
    return (
        <div className="global-spinner-overlay"> {/* Full-screen overlay */}
            <Box className="spinner-container" sx={{ position: 'relative', display: 'inline-flex' }}>
                {/* Circular Spinner */}
                <CircularProgress
                    size={200} // Adjust size if needed
                    thickness={4}
                    sx={{
                        color: '#1976d2', // Customize color as needed
                        animationDuration: '1500ms'
                    }}
                />
                {/* Logo */}
                <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    className="spinner-logo"
                />
            </Box>
        </div>
    );
};

export default GlobalSpinner;
